<template>
  <div
    class="topic-list-component app-flex-row"
    :style="{ margin: `0 -${gutter}px` }"
  >
    <TopicItem
      v-for="item in list"
      :key="item.id"
      :item="item"
      :style="{ marginLeft: `${gutter}px`, marginRight: `${gutter}px` }"
      :link-target="linkTarget"
    ></TopicItem>
  </div>
</template>

<script>
import TopicItem from './TopicItem'

export default {
  components: {
    TopicItem
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    gutter: {
      type: [Number, String],
      default: 12
    },
    // 是否需要在新tab页打开
    linkTarget: { type: String, default: '_seft' }
  }
}
</script>
